import { Typography } from "@mui/material";

interface TimeRemainingformattedProps {
	remainingMinutes: number;
}

export const TimeRemainingFormatted = ({ remainingMinutes }: TimeRemainingformattedProps) => {
	let remainingHoursFormatted = remainingMinutes >= 60 ? Math.floor(remainingMinutes / 60) : "0";
	let remainingMinutesFormatted = remainingMinutes > 0 ? ("00" + (Math.floor(remainingMinutes) % 60)).slice(-2) : "00";

	let hours = (
		<>
			<Typography variant="inherit" component="span">
				{remainingHoursFormatted}
			</Typography>
			<Typography variant="inherit" component="span" sx={{ fontSize: "smaller" }}>
				h
			</Typography>
		</>
	);

	let minutes = (
		<>
			<Typography variant="inherit" component="span">
				{remainingMinutesFormatted}
			</Typography>
			<Typography variant="inherit" component="span" sx={{ fontSize: "smaller" }}>
				m
			</Typography>
		</>
	);

	return (
		<>
			{hours} {minutes}
		</>
	);
};

export default TimeRemainingFormatted;
